<ion-card-content class="ion-no-padding">
  <ion-grid>
    <ion-row>
      <ion-col size="12" size-md="4">
        <div class="search">
          <h4>{{ "generic.employees" | translate | uppercase }}</h4>
          <ion-searchbar
            mode="ios"
            class="section-search-custom"
            [placeholder]="'generic.searchByName' | translate"
            (keyup)="updateSearch($event.target.value)"
          ></ion-searchbar>
        </div>

        <ul class="subordinates">
          <li
            *ngFor="let user of displayedUsers"
            (click)="selectUser(user)"
            [ngClass]="{ selected: selectedUser?.id === user.id }"
          >
            <ion-avatar slot="start">
              <img [src]="getImageUrl(user.imageUrl)" default="" alt="" />
            </ion-avatar>
            <ion-label>
              {{ user.name }}
            </ion-label>
          </li>
          <ion-row
            *ngIf="
              displayedUsers &&
              displayedUsers.length > 0 &&
              originalUsers &&
              displayedUsers.length !== originalUsers.length
            "
            class="noBorder showClick"
            style="width: 100%"
          >
            <div (click)="showMoreUsers()" style="cursor: pointer">
              {{ "generic.showMore" | translate | titlecase }}
            </div>
          </ion-row>
        </ul>
      </ion-col>

      <ion-col size="12" size-md="8">
        <div class="selected-user" *ngIf="selectedUser">
          <ion-avatar slot="start">
            <img [src]="getImageUrl(selectedUser.imageUrl)" default="" alt="" />
          </ion-avatar>
          <ion-label>
            {{ selectedUser.name }}
          </ion-label>
        </div>
        <div class="notes">
          <div class="new-comment" *ngIf="selectedUser">
            <ion-item lines="none">
              <ion-label position="floating">
                {{ "notepad.addComment" | translate | uppercase }}
              </ion-label>
              <ion-textarea
                [(ngModel)]="currentNote.text"
                [placeholder]="'generic.writeToReply' | translate"
              ></ion-textarea>
            </ion-item>
            <div class="actions">
              <p
                class="cancel"
                (click)="cancelEdit(selectedUser.id, currentNote.id)"
              >
                {{ currentNote.id ? ("notepad.cancelEdit" | translate) : "" }}
              </p>
              <ion-button
                color="primary"
                mode="ios"
                [disabled]="!selectedUser || !currentNote.text"
                (click)="saveNote(currentNote)"
              >
                {{ "generic.save" | translate }}
              </ion-button>
            </div>
          </div>

          <p
            class="empty"
            *ngIf="selectedUser && selectedUser.notes?.length === 0"
          >
            {{ "notepad.noNotes" | translate }}
          </p>
          <ion-list class="users">
            <ion-item *ngFor="let note of selectedUser?.notes" lines="none">
              <ion-avatar slot="start">
                <img [src]="getImageUrl(currentUser.imageUrl)" default="" alt="" />
              </ion-avatar>
              <p class="note">
                <span class="title">
                  {{ currentUser.name }}
                </span>
                <span class="date">
                  {{ note.createdAt | date : "dd/MM/yyyy" }} </span
                ><br />
                {{ note.text }}
              </p>
              <ion-buttons>
                <ion-button
                  color="primary"
                  fill="clear"
                  mode="ios"
                  (click)="editNote(note)"
                >
                  <ion-icon class="bp-edit" slot="end"></ion-icon>
                </ion-button>
                <ion-button
                  class="delete"
                  color="danger"
                  fill="clear"
                  mode="ios"
                  (click)="confirmDeleteNote(note.id)"
                >
                  <ion-icon class="bp-delete"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-item>
            <ion-row
              *ngIf="
                selectedUser &&
                selectedUser?.notes.length > 0 &&
                selectedUser?.notes.length !== selectedNotesUser
              "
              class="noBorder showClick"
              style="width: 100%"
            >
              <div (click)="showMoreNotes()" style="cursor: pointer">
                {{ "generic.showMore" | translate | titlecase }}
              </div>
            </ion-row>
          </ion-list>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card-content>
